<template>
  <div class="hbb_brankBox">
    <h2>
      您所关注的前30个品牌
      <span>
        <img src="@assets/images/weixian.png" alt="" /> 您可在"智配Store APP -
        我的 - 关注的智能产品目录"中进行排序和添加新品牌操作</span
      >
    </h2>
    <!-- 选中的类名 class="hbb_brankSelect" -->
    <span
      :class="[
        item.isSelect ? 'hbb_brankSelect' : '',
        item.isEnable ? 'sdw_brankEnable' : 'sdw_brankDisable',
      ]"
      v-for="(item, index) in validBrands"
      :key="index"
      v-if="item.isEnable"
      @click="oneItemClick(item)"
    >
      {{ item.brandName }}
      <b v-if="item.isSelect">x</b>
    </span>
    <!-- <div v-if="validBrands.length>20" class="hbb_lookAll" @click="lookAllClick">{{showTextType == 1? '查看全部': '收起'}}</div> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      partListClick: [], //可点击品牌集合
      validBrands: [], // 取得可用品牌集合
      showListNum: 20, // 页面默认最多展示的条数
      showTextType: 1, // 默认查看全部
    };
  },
  computed: {
    ...mapGetters({
      isCreated: "CommonModule/getViewModalOver",
    }),
  },
  methods: {
    ...mapMutations({
      setViewModalOver: "CommonModule/SET_VIEWMODALOVER",
    }),
    // 重置品类有效性
    resetBrandEnable(enableBrands) {
      this.validBrands.forEach((oneBrand) => {
        oneBrand.isEnable = enableBrands.indexOf(oneBrand.brandId) > -1;
        oneBrand.isSelect = false;
        let current = this.validBrands.indexOf(oneBrand);
        this.$set(this.validBrands, current, oneBrand);
      });
    },
    setPartListClick(val) {
      this.partListClick = val;
    },
    oneItemClick(item) {
      // 点击每个品牌
      if (!this.isCreated) {
        this.$message({
          type: "info",
          message: "当前列表数据未加载完，为了您的操作流畅性，请稍后重试",
        });
        return false;
      }
      if (!item.isEnable) return false;

      if (!this.partListClick.includes(item.brandId)) {
        this.$message({
          type: "info",
          message: "该品牌暂无无适配件",
        });
        return false;
      }
      this.validBrands
        .filter((x) => {
          return x.brandId == item.brandId;
        })
        .map((y) => {
          y.isSelect = !y.isSelect;
          let current = this.validBrands.indexOf(y);
          this.$set(this.validBrands, current, y);
        });
      this.$emit("brandOneClick", item.brandId);
    },
    lookAllClick() {
      let maxLength = this.validBrands.length;
      if (this.showTextType == 1) {
        this.showListNum = maxLength;
        this.showTextType = 2;
      } else {
        this.showListNum = 20;
        this.showTextType = 1;
      }
    },
  },
};
</script>

<style>
.hbb_brankBox {
  float: left;
  width: 100%;
  background: #fff;
  padding: 10px 20px 20px;
  position: relative;
  cursor: pointer;
}
.hbb_brankBox h2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.hbb_brankBox h2 span {
  background: rgba(231, 76, 60, 0.08);
  margin-top: 0;
  border: 1px solid rgba(231, 76, 60, 0.2);
  color: rgba(231, 76, 60, 0.8);
  display: flex;
  align-items: center;
  margin-right: 0;
}
.hbb_brankBox h2 span img {
  height: 13px;
  margin-right: 4px;
}
.hbb_brankBox span {
  float: left;
  font-size: 12px;
  width: auto;
  border: 1px solid #ddd;
  text-align: center;
  margin-right: 16px;
  padding: 0 20px;
  height: 28px;
  line-height: 28px;
  margin-top: 10px;
  position: relative;
  color: #656565;
}
.hbb_brankBox span.hbb_brankSelect {
  background: #ffeeec;
  border: 1px solid #ff8c81;
}
.hbb_brankBox span.sdw_brankDisable {
  background: gray;
}
.hbb_brankBox span b {
  color: #fff;
  position: absolute;
  top: 0;
  right: 0;
  background: #ff8d81;
  border-left: 1px solid #ff8c81;
  border-bottom: 1px solid #ff8c81;
  width: 15px;
  height: 15px;
  line-height: 15px;
}
.hbb_lookAll {
  position: absolute;
  right: 25px;
  bottom: 20px;
  font-size: 14px;
  cursor: pointer;
  color: #377de8;
}
</style>